import React from 'react';
import { IconProps } from './types';

export const InfoIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      id="Laag_2"
      data-name="Laag 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={className}
    >
      <title>{title}</title>
      <path d="M15,1A14,14,0,1,0,29,15,14,14,0,0,0,15,1Zm0,26A12,12,0,1,1,27,15,12,12,0,0,1,15,27Z" />
      <rect x="13.37" y="7.95" width="3.44" height="9.69" />
      <path d="M15.08,18.76A1.89,1.89,0,1,0,17,20.64,1.86,1.86,0,0,0,15.08,18.76Z" />
    </svg>
  );
};
